import React from 'react';
import {
  Button,
  Input,
  InputGroup,
  Spinner,
  Stack,
  Text,
  ButtonGroup,
  VisuallyHidden,
  createIcon,
} from '@chakra-ui/react';
import { BsTelegram, BsTwitter } from 'react-icons/bs';
import { FcGoogle } from 'react-icons/fc';
import { validator } from '@/utils/validation';
import { storage } from '@/utils/storage';
import { formatter } from '@shop/utils/formatter';
import Logo from '../logo';

export const TelegramIcon = createIcon({
  displayName: 'TelegramIcon',
  path: <BsTelegram />,
});

export const GoogleIcon = createIcon({
  displayName: 'GoogleIcon',
  path: <FcGoogle />,
});

export const TwitterIcon = createIcon({
  displayName: 'TwitterIcon',
  path: <BsTwitter />,
});

const providers = [
  { name: 'Google', icon: <GoogleIcon boxSize="8" marginTop={'2.5'} /> },
  {
    name: 'Twitter',
    icon: <TwitterIcon boxSize="6" color={'twitter.500'} marginTop={'1.5'} />,
  },
  {
    name: 'Telegram',
    icon: <TelegramIcon marginTop={3} color={'telegram.500'} boxSize="7" />,
  },
];

export const OAuthButtonGroup = ({ disabled }: { disabled: boolean }) => (
  <ButtonGroup variant="outline" spacing="4" width="full">
    {providers.map(({ name, icon }) => (
      <Button isDisabled={disabled} key={name} width="full">
        <VisuallyHidden>Sign in with {name}</VisuallyHidden>
        {icon}
        <Text
          marginTop={'1'}
          marginX={'2'}
          color={'gray.400'}
          fontSize={'small'}
        >
          {name}
        </Text>
      </Button>
    ))}
  </ButtonGroup>
);

type Props = {
  sendOtp: (mobileNumber: string) => Promise<void>;
};
export default function MobileInput({ sendOtp }: Props) {
  const [mobileNumber, setMobileNumber] = React.useState(
    () => storage.session.mobile.get() || '',
  );
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  async function handleSendOtp() {
    try {
      const error = validator.mobile(mobileNumber);
      if (error) {
        setError(error);
        return;
      }
      setIsLoading(true);
      await sendOtp(mobileNumber);
      storage.session.mobile.set(mobileNumber);
    } finally {
      setIsLoading(false);
    }
  }

  function handleMobileChange(e: React.ChangeEvent<HTMLInputElement>) {
    const value = formatter.number.toEn(e.target.value);
    if (value && !validator.number(value)) return;
    setError(null);
    setMobileNumber(value);
  }

  const isSubmitDisabled = isLoading || mobileNumber.length != 11 || !!error;

  return (
    <Stack px={4} py={6} bgColor={'white'} rounded={'xl'}>
      <Logo mx="auto" />
      <Text fontSize={'sm'} fontWeight={600} align={'center'} mt={4}>
        ورود به حساب کاربری
      </Text>
      <Text fontSize={'xs'} align={'center'} mb={5}>
        شماره همراه خود را وارد کنید
      </Text>
      <InputGroup flexDir={'column'} mb={12}>
        <Input
          type="text"
          id="mobileNumber"
          name="mobileNumber"
          autoComplete="phone"
          textAlign={'left'}
          placeholder="09"
          _placeholder={{ textAlign: 'end' }}
          value={formatter.number.e2p(mobileNumber)}
          onChange={handleMobileChange}
          maxLength={11}
          variant={'filled'}
        />
        {error && (
          <Text fontSize={'xs'} color={'red.500'} mt={'1'}>
            {error}
          </Text>
        )}
      </InputGroup>

      <Text fontSize={'xs'} textAlign={'center'} color={'gray.600'} mb={2}>
        با ورود خود تمامی حقوق و شرایط پینتورا را میپذیرم
      </Text>
      <Button
        isDisabled={isSubmitDisabled}
        onClick={handleSendOtp}
        bgColor={'black'}
        color={'white'}
        _hover={{
          bgColor: 'blackAlpha.700',
        }}
      >
        {isLoading ? <Spinner /> : 'دریافت کد تایید'}
      </Button>

      {/* <Stack direction={'row'} align={'center'}>
          <Divider />
          <Text width={200} align={'center'} color={'gray.300'}>
            {'یا ورود با'}
          </Text>
          <Divider />
        </Stack>

        <OAuthButtonGroup disabled={isLoading} /> */}
    </Stack>
  );
}
